import type { ReactNode } from 'react'
import { Copy, t } from '@stokr/components-library'
import { ChartNote, ChartNoteLink, Footnote } from './chart.styles'

interface ChartFootnoteProps {
  asOf?: string
  source?: string
  /** Appended after the date and source, e.g. a download action. */
  children?: ReactNode
}

/** "As of 31 Aug 2026 - Source: Polygon.io", under a chart card, then e.g. a download action. */
export const ChartFootnote = ({ asOf, source, children }: ChartFootnoteProps) => {
  const text = [
    asOf && t('stoPage.heroChart.asOf', { date: asOf }),
    source && t('stoPage.heroChart.source', { source }),
  ]
    .filter(Boolean)
    .join(' - ')
  if (!text && !children) return null
  return (
    <Footnote>
      {text}
      {text && children && ' - '}
      {children}
    </Footnote>
  )
}

const DASHBOARD_URL = 'https://bmn2.mining.blockstream.com'

/** BMN2's BTC mined comes from its mining dashboard: where from, under the chart, the dashboard linked. */
export const MinedSourceNote = () => (
  <ChartNote>
    <Copy id="stoPage.heroChart.minedSource.before" />
    <ChartNoteLink href={DASHBOARD_URL} target="_blank" rel="noopener noreferrer">
      <Copy id="stoPage.heroChart.minedSource.link" />
    </ChartNoteLink>
    <Copy id="stoPage.heroChart.minedSource.after" />
  </ChartNote>
)
